import { render, staticRenderFns } from "./Pover.vue?vue&type=template&id=668d1bde"
import script from "./Pover.vue?vue&type=script&lang=ts"
export * from "./Pover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports